<template>
  <div class="recruit" :class="[ getTerminalForChrome() ? 'recruit-mo': 'recruit-pc']">
    <div class="list">
      <div class="list-item" v-for="(v, i) in list" :key="i">
        <!-- <div class="top" :style="{background: 'url(' + v.thumbUrl + ') no-repeat center center'}"> -->
          <!-- <div class="text">{{v.rulestitle}}</div>
        </div>
        <div class="bottom">[{{v.rec_createdtime_str}}]</div> -->
        <div class="image" @click="toDetail(v)">
          <img :src="v.thumbUrl || defaultImg" alt="">
          <!-- <span class="wave"></span>
          <span class="wave"></span>
          <span class="wave"></span> -->
        </div>
        <div class="title" @click="toDetail(v)" :title="v.surveytitle" :style="{fontWeight: v.wider === '1' ? 'bold' : 'normal', color: v.tored === '1' ? 'red' : 'rgba(0,0,0,.9)'}">{{v.surveytitle}}</div>
        <div class="date">[{{v.rec_createdtime_str}}]</div>
      </div>
    </div>
    <Page :total="total" show-total @on-change="pageChange" style="text-align: center"></Page>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { fetchSurvey } from '@/api/school';
export default {
  data() {
    return {
      params: {
        pageNumber: 1,
        pageSize: 9,
        category: this.$route.query.id
      },
      total: 0,
      list: [],
      defaultImg: require('../../assets/default.jpeg')
    };
  },
  watch: {
    '$route.query': function(val) {
      this.params.category = val.id;
      this._fetchSurvey();
    }
  },
  methods: {
    ...mapGetters(['getTerminalForChrome']),
    toDetail(val) {
      // bus.detailContent = val
      // sessionStorage.setItem('detailMsg', JSON.stringify(val))
      this.$router.push({
        path: `/detail?categorybelong=${val.categorybelong}&rec_id=${val.rec_id}`
      })
    },
    pageChange(val) {
      this.params.pageNumber = val;
      this._fetchSurvey();
    },
    _fetchSurvey() {
      fetchSurvey({ ...this.params }).then(res => {
        if (res.status === 200) {
          this.list = res.data.data;
          this.total = res.data.totalCount;
        }
      });
    }
  },
  mounted() {
    this._fetchSurvey();
  }
};
</script>

<style scoped lang="scss">
.recruit-pc {
  padding: 48px 0px;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  .list {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .list-item {
      width: 33.33%;
      // margin-bottom: 16px;
      display: inline-block;
      padding-right: 30px;
      padding-left: 30px;
      padding-bottom: 16px;
      .image {
        // width: 330px;
        width: 100%;
        // height: 240px;
        // height: 346px;
        overflow: hidden;
        position: relative;
        background-image: linear-gradient(rgb(20, 224, 197) 60%,
            rgba(19, 223, 230, 0.8));
        opacity: 0.9;
        cursor: pointer;
        transition: transform .3s;
        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
          vertical-align: middle;
        }
        &:hover {
          // box-shadow: 0px 5px 10px 0px rgb(177, 174, 174);
          transform: scale(1.1);
          .wave {
            position: absolute;
            width: 550px;
            height: 550px;
            top: 200px;
            left: -100px;
            background-color: rgba(111, 194, 243, 0.3);
            border-radius: 38%;
            animation: drift 5s linear infinite;
          }
      
          .wave:nth-of-type(1) {
            animation-duration: 5s;
          }
      
          .wave:nth-of-type(2) {
            animation-duration: 7s;
          }
      
          .wave:nth-of-type(3) {
            animation-duration: 10s;
          }
      
          @keyframes drift {
            from {
              transform: rotate(180deg);
            }
          }
        }
      }
      .title {
        width: 100%;
        font-size: 18px;
        color: rgba(0,0,0,.9);
        // font-weight: 700;
        text-align: center;
        // margin: 10px 0px;
        margin-top: 16px;
        margin-bottom: 5px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .date {
        width: 100%;
        font-size: 16px;
        color: #999;
        text-align: center;
      }
      .top {
        width: 318px;
        height: 346px;
        font-size: 28px;
        color: #ffffff;
        .text {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(200, 230, 200, 0.5);
          text-align: center;
          &:hover {
            background: rgba(111, 206, 111, 0.8);
          }
        }
      }
      .bottom {
        text-align: center;
        margin-top: 16px;
      }
    }
  }
}
.recruit-mo {
  padding: 6.4vw 2.67vw 2.67vw 2.67vw;
  .list {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    // margin-bottom: 2.13vw;
    .list-item {
      margin-bottom: 5.33vw;
      width: 45.87vw;
      
      .image {
        width: 100%;
        // width: 45.87vw;
        height: 34.71vw;
        // height: 49.6vw;
        box-shadow: 0px 2px 4px 0px;
        // transition: transform 0.3s;
        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
        // &:hover {
        //   transform: scale(1.1);
        // }
      }
      .title {
        color: rgba(0,0,0,.9);
        text-align: center;
        margin: 2.13vw 0vw;
        font-size: 3.73vw;
        font-weight: 700;
      }
      .date {
        text-align: center;
        font-size: 3.2vw;
        color: #999;
      }
      .top {
        width: 45.87vw;
        height: 49.6vw;
        font-size: 4.27vw;
        color: #ffffff;
        .text {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(200, 230, 200, 1);
          text-align: center;
        }
      }
      .bottom {
        margin-top: 3.2vw;
        text-align: center;
        font-size: 3.2vw;
        color: #333;
      }
    }
  }
}
</style>
